import { useState, useEffect } from 'react';
import { getTicketsHistory, cancelTicket, type Ticket } from '../../api/tickets.api';

export default function BoletosPage() {
    const [tickets, setTickets] = useState<Ticket[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            const data = await getTicketsHistory();
            setTickets(data);
        } catch (error) {
            console.error('Error loading tickets:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = async (id: string, numero: string) => {
        if (!confirm(`¿Está seguro de cancelar el ticket ${numero}? Esta acción liberará el vehículo.`)) {
            return;
        }

        try {
            await cancelTicket(id);
            alert('Ticket cancelado exitosamente');
            await loadData();
        } catch (error: any) {
            console.error('Error canceling ticket:', error);
            alert(error.response?.data?.message || 'Error al cancelar el ticket');
        }
    };

    return (
        <>
            <div className="p-4 sm:p-6">
                <div className="mb-6">
                    <h1 className="text-xl sm:text-2xl font-bold text-slate-800">Boletos Emitidos</h1>
                    <p className="text-sm text-slate-500">Historial de tickets generados en entrada.</p>
                </div>

                <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
                    <div className="overflow-x-auto">
                    <table className="w-full text-left">
                        <thead className="bg-slate-50 border-b border-slate-200">
                            <tr>
                                <th className="px-6 py-3 text-xs font-bold text-slate-500 uppercase tracking-wider">Número</th>
                                <th className="px-6 py-3 text-xs font-bold text-slate-500 uppercase tracking-wider">Vehículo</th>
                                <th className="px-6 py-3 text-xs font-bold text-slate-500 uppercase tracking-wider">Fecha Entrada</th>
                                <th className="px-6 py-3 text-xs font-bold text-slate-500 uppercase tracking-wider">Operador</th>
                                <th className="px-6 py-3 text-xs font-bold text-slate-500 uppercase tracking-wider text-center">Estado</th>
                                <th className="px-6 py-3 text-xs font-bold text-slate-500 uppercase tracking-wider text-center">Acciones</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-100">
                            {loading ? (
                                <tr>
                                    <td colSpan={6} className="px-6 py-8 text-center text-slate-500">
                                        <i className="ri-loader-4-line animate-spin text-2xl"></i>
                                    </td>
                                </tr>
                            ) : tickets.length === 0 ? (
                                <tr>
                                    <td colSpan={6} className="px-6 py-8 text-center text-slate-500">
                                        No hay boletos registrados.
                                    </td>
                                </tr>
                            ) : (
                                tickets.map((t) => (
                                    <tr key={t.id} className="hover:bg-slate-50/50">
                                        <td className="px-6 py-4 font-bold text-slate-800">
                                            {t.numero}
                                        </td>
                                        <td className="px-6 py-4">
                                            <div className="font-medium text-slate-800">{t.vehiculo?.placa || '-'}</div>
                                            <div className="text-xs text-slate-500">{t.vehiculo?.tipo || 'Desconocido'}</div>
                                        </td>
                                        <td className="px-6 py-4 text-sm text-slate-600">
                                            {new Date(t.createdAt).toLocaleString()}
                                        </td>
                                        <td className="px-6 py-4 text-sm text-slate-600">
                                            {t.operador?.nombre || 'Desconocido'}
                                        </td>
                                        <td className="px-6 py-4 text-center">
                                            <span className={`px-2 py-1 rounded-full text-xs font-bold ${
                                                t.status === 'ACTIVO' ? 'bg-blue-100 text-blue-700' : 
                                                t.status === 'CANCELADO' ? 'bg-red-100 text-red-700' :
                                                'bg-slate-100 text-slate-600'
                                            }`}>
                                                {t.status || 'ACTIVO'}
                                            </span>
                                        </td>
                                        <td className="px-6 py-4 text-center">
                                            {t.status === 'ACTIVO' && (
                                                <button
                                                    onClick={() => handleCancel(t.id, t.numero)}
                                                    className="px-3 py-1.5 bg-red-500 hover:bg-red-600 text-white text-xs font-medium rounded-lg transition cursor-pointer"
                                                    title="Cancelar ticket"
                                                >
                                                    <i className="ri-close-circle-line mr-1"></i>
                                                    Cancelar
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            </div>
        </>
    );
}
